import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { CheckSomething } from './components/CheckSomething';
import { RiskReview } from './components/RiskReview';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { TrainingPublic } from './training/TrainingPublic';
import { TrainingCatalog } from './training/TrainingCatalog';
import { ModuleDetail } from './training/ModuleDetail';
import { LessonViewer } from './training/LessonViewer';
import { TrainingPlans } from './training/TrainingPlans';
import { TeamDashboard } from './training/TeamDashboard';
import { CompletionRecords } from './training/CompletionRecords';
import { TrainingSessionProvider } from './training/session';
import { PersonaSwitcher } from './training/PersonaSwitcher';
import './training/training.css';

function SiteNav() {
  return (
    <nav className="nav">
      <div className="container">
        <div className="nav-inner">
          <Link to="/" className="nav-logo">
            EverydaySecurity
            <span className="logo-dot"></span>
          </Link>
          <a href="https://everydaysecurity.ai" className="nav-back">
            <i className="ti ti-arrow-left" aria-hidden="true"></i>
            <span>everydaysecurity.ai</span>
          </a>
        </div>
      </div>
    </nav>
  );
}

function SiteFooter() {
  return (
    <footer className="footer">
      <div className="container">
        <p>© 2026 EverydaySecurity. Security for teams without a security team.</p>
        <div className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <span className="separator">·</span>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}

function AppShell() {
  return (
    <div className="app">
      <PersonaSwitcher />
      <SiteNav />

      <main className="main">
        <Routes>
          <Route path="/" element={<CheckSomething />} />
          <Route path="/scam-checker" element={<Navigate to="/" replace />} />
          <Route path="/risk-review" element={<RiskReview />} />
          <Route path="/training" element={<TrainingPublic />} />
          <Route path="/training/catalog" element={<TrainingCatalog />} />
          <Route path="/training/module/:moduleId" element={<ModuleDetail />} />
          <Route path="/training/module/:moduleId/lesson/:lessonN" element={<LessonViewer />} />
          <Route path="/training/plans" element={<TrainingPlans />} />
          <Route path="/training/team" element={<TeamDashboard />} />
          <Route path="/training/records" element={<CompletionRecords />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </main>

      <SiteFooter />
    </div>
  );
}

function App() {
  return (
    <TrainingSessionProvider>
      <Router>
        <AppShell />
      </Router>
    </TrainingSessionProvider>
  );
}

export default App;
